export var escapeUri = function escapeUri(uri) {
  // AWS percent-encodes some extra non-standard characters in a URI
  return encodeURIComponent(uri).replace(/[!'()*]/g, hexEncode);
};

var hexEncode = function hexEncode(c) {
  return "%" + c.charCodeAt(0).toString(16).toUpperCase();
};